import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'persianNumber',
    pure: false
})
export class PersianNumberPipe implements PipeTransform {
    constructor(private translate: TranslateService) { }

    transform(value: any): string {
        if ((value === undefined || value === null) ||
            (this.translate.currentLang && this.translate.currentLang.toLowerCase() !== "fa")) {
            // return this.toEnglishNumber(value.toString());
            return value;
        }
        return this.toPersianNumber(value.toString());
    }
    public toPersianNumber(number: string): string {
        if (number === undefined) {
            return '';
        }
        let str = number.toString().trim();
        if (str === '') {
            return '';
        }
        str = str.replace(/0/g, '۰');
        str = str.replace(/1/g, '۱');
        str = str.replace(/2/g, '۲');
        str = str.replace(/3/g, '۳');
        str = str.replace(/4/g, '۴');
        str = str.replace(/5/g, '۵');
        str = str.replace(/6/g, '۶');
        str = str.replace(/7/g, '۷');
        str = str.replace(/8/g, '۸');
        str = str.replace(/9/g, '۹');
        return str;
    }
    public toEnglishNumber(number: string): string {
        if (number === undefined) {
            return '';
        }
        let str = number.toString().trim();
        if (str === '') {
            return '';
        }
        str = str.replace('۰', '0');
        str = str.replace('۱', '1');
        str = str.replace('۲', '2');
        str = str.replace('۳', '3');
        str = str.replace('۴', '4');
        str = str.replace('۵', '5');
        str = str.replace('۶', '6');
        str = str.replace('۷', '7');
        str = str.replace('۸', '8');
        str = str.replace('۹', '9');
        return str;
    }
}
